function toCamel(s) {
  return s && ('' + s).replace(/-(\w)?/g, function (x) {
    return x[1].toLocaleUpperCase()
  })
}

function camelify(obj) {
  var res = Object.keys(obj).reduce(function(r, c) {
    var temp = {}
    temp[toCamel(c)] = obj[c]
    return Object.assign(r, temp)
  }, {})
  return Object.assign({}, obj, res, {})
}

function camelifyImport(obj) {
  if (obj && obj.__esModule && obj.default) {
    var camelCased = camelify(obj.default)
    return Object.assign({}, obj, camelCased, { default: camelCased })
  } else {
    return camelify(obj)
  }
}

module.exports = {
  variables: require('./variables.json'),
  colors: camelifyImport(require('./colors.json')),
  midas: camelifyImport(require('./midas.module.scss')),
}